import Vue from "vue";

export const CHECK = state => {
  state.authenticated = !!localStorage.getItem("auth_token");
  if (state.authenticated) {
    var auth_type = null;
    if (localStorage.getItem("auth_type") !== null) {
      auth_type = localStorage.getItem("auth_type");
    }
    if (auth_type && auth_type == "jwt") {
      Vue.$axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
        "auth_token"
      )}`;
    } else {
      Vue.$axios.defaults.headers.common.Authorization = `Basic ${localStorage.getItem(
        "auth_token"
      )}`;
    }
  }
};

export const LOGIN = (state, payload) => {
  state.authenticated = true;
  localStorage.setItem("auth_token", payload.token);
  if (payload.auth_type) {
    localStorage.setItem("auth_type", payload.auth_type);
  }
  if (payload.auth_type && payload.auth_type == "jwt") {
    Vue.$axios.defaults.headers.common.Authorization = `Bearer ${payload.token}`;
  } else {
    Vue.$axios.defaults.headers.common.Authorization = `Basic ${payload.token}`;
  }
};

export const LOGOUT = state => {
  state.authenticated = false;
  localStorage.removeItem("auth_token");
  localStorage.removeItem("auth_type");
  Vue.$axios.defaults.headers.common.Authorization = "";
};
